export default class SelectArray extends Array {}
